// extracted by mini-css-extract-plugin
export default {"downPaymentSubtext":"DownPaymentSubtext_downPaymentSubtext__YerX+","updateToPmiPercentButton":"DownPaymentSubtext_updateToPmiPercentButton__cZeaG"};